// src/layouts/AdminLayout.tsx
import type { ReactNode } from "react";
import { SidebarShell } from "@/components/shared/nav"; // adjust alias if needed
import PageLoadingScreen from "@/components/shared/ui/PageLoadingScreen";
import { useLocationCatalog } from "@/lib/locationCatalog";

export default function AdminLayout({ children }: { children: ReactNode }) {
  // Country/region/city pickers read the location catalogue synchronously, so
  // screens must not mount before it has arrived. This costs one short wait on
  // the first admin page of a session; afterwards the cache is warm and this
  // is a no-op. A failed fetch does not block the app — screens then render
  // with empty location lists rather than not at all.
  const catalog = useLocationCatalog();

  return (
    <SidebarShell>
      {catalog.isLoading ? (
        <PageLoadingScreen fullscreen={false} label="Loading…" />
      ) : (
        children
      )}
    </SidebarShell>
  );
}
